import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
var FileReference = /** @class */ (function (_super) {
    __extends(FileReference, _super);
    function FileReference() {
        return _super.call(this) || this;
    }
    Object.defineProperty(FileReference.prototype, "size", {
        get: function () {
            return this._size;
        },
        set: function (value) {
            this._size = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "extension", {
        get: function () {
            return this._extension;
        },
        set: function (value) {
            this._extension = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "permissionStatus", {
        get: function () {
            return this._permissionStatus;
        },
        set: function (value) {
            this._permissionStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._type = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "creator", {
        get: function () {
            return this._creator;
        },
        set: function (value) {
            this._creator = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "modificationDate", {
        get: function () {
            return this._modificationDate;
        },
        set: function (value) {
            this._modificationDate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "creationDate", {
        get: function () {
            return this._creationDate;
        },
        set: function (value) {
            this._creationDate = value;
        },
        enumerable: true,
        configurable: true
    });
    //Displays a file-browsing dialog box that lets the user select a file to upload.
    FileReference.prototype.browse = function (typelist) {
        window.alert('AwayJS: flash.net.FileReference::browse not implemented !');
        return true;
    };
    //Starts the upload of the file to a remote server.
    FileReference.prototype.upload = function (url) {
        console.log('upload not implemented yet in flash/FileReference');
        return true;
    };
    //Starts the load of a local file selected by a user.
    FileReference.prototype.load = function () {
        console.log('load not implemented yet in flash/FileReference');
    };
    //Opens a dialog box that lets the user save a file to the local filesystem.
    FileReference.prototype.save = function (data, defaultFileName) {
        if (defaultFileName === void 0) { defaultFileName = null; }
        window.alert('AwayJS: flash.net.FileReference::save not implemented !');
    };
    //Requests permission to access filesystem.
    FileReference.prototype.requestPermission = function () {
        console.log('upload not implemented yet in flash/FileReference');
    };
    //Opens a dialog box that lets the user download a file from a remote server.
    FileReference.prototype.download = function (url, defaultFileName) {
        console.log('download not implemented yet in flash/FileReference');
        return true;
    };
    //Cancels any ongoing upload or download operation on this FileReference object.
    FileReference.prototype.cancel = function () {
        console.log('cancel not implemented yet in flash/FileReference');
    };
    return FileReference;
}(EventDispatcher));
export { FileReference };
